// External store for communicating camera preset triggers from the sidebar UI
// into the R3F Canvas (same pattern as previewDimensions.ts)

type Listener = () => void

interface CameraPresetState {
  position: number[]
  rotation: number[]
  version: number
}

let state: CameraPresetState = {
  position: [0, 0, 0],
  rotation: [0, 0, 0],
  version: 0,
}

const listeners = new Set<Listener>()

const notify = () => {
  listeners.forEach((l) => l())
}

/** Trigger a camera preset — called from the sidebar panel */
const triggerCameraPreset = (position: number[], rotation: number[]) => {
  state = {position, rotation, version: state.version + 1}
  notify()
}

/** Get current snapshot — used by useSyncExternalStore */
const getSnapshot = (): CameraPresetState => state

/** Subscribe — used by useSyncExternalStore */
const subscribe = (listener: Listener): (() => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export {triggerCameraPreset, getSnapshot, subscribe}
export type {CameraPresetState}
